import React from "react";
import {Box, List, ListItem, ListItemButton, Divider, Stack, Typography, alpha} from "@mui/material";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import { HeaderNavProps } from "@/components/header/common/types";
import { NavigationType } from "@/components/header/common/header-enums";
import LoginNavItem from "@/components/header/navigation/login/login-nav-item";

type MobilePrimaryNavigationItemsProps = {
  headerNavProps: HeaderNavProps[];
  setSecondaryNavItems: (destination: HeaderNavProps[]) => void;
  setCurrentPrimaryNavLabel: (currentPrimaryNavLabel: string) => void;
  setActiveNavigation: (activeNavigation: NavigationType) => void;
};

export default function MobilePrimaryNavigationItems(props: MobilePrimaryNavigationItemsProps) {
  const { headerNavProps, setSecondaryNavItems, setCurrentPrimaryNavLabel, setActiveNavigation } = props;

  const handleItemClick = (d: HeaderNavProps) => {
    const secondary = d.fields.subNavList ?? [];
    const hasSubNav = secondary?.length;

    if (hasSubNav) {
      setSecondaryNavItems(secondary);
      setCurrentPrimaryNavLabel(d.fields.title);
      setActiveNavigation(NavigationType.secondary);
    } else {
      window.location.href = d.fields.url;
    }
  };

  return (
    <Stack>
      <Stack
        sx={{
          position: "fixed",
          zIndex: 999,
          left: 0,
          top: 200,
          width: "100%",
          height: "100dvh",
          overflow: "hidden",
          display: "flex",
          flexShrink: 0,
          flexDirection: "column",
          gap: 1,
          borderColor: "divider",
          backgroundColor: "primary.main"
        }}
      >
        <Box
          sx={{
            position: "fixed",
            top: 200,
            left: 0,
            width: "100vw",
            height: "100%",
            backgroundColor: "var(--isagent-mobile-background-color)"
          }}
        />
        <Box
          sx={{
            minHeight: 0,
            overflow: "hidden auto",
            flexGrow: 1,
            display: "flex",
            flexDirection: "column"
          }}
        >
          <List
            sx={{
              gap: 1,
              overflow: "hidden",
              "--List-nestedInsetStart": "30px",
              paddingTop: 0
            }}
          >
            {headerNavProps.map((primaryNavItem) => (
              <ListItem
                key={primaryNavItem.sys.id}
                component="li"
                sx={{ nestingLevel: 1, paddingTop: 0 , paddingBottom: 0 }}
              >
                <ListItemButton
                  onClick={() => handleItemClick(primaryNavItem)}
                  data-nav-level="primary"
                  data-nav-label={primaryNavItem.fields.title}
                  sx={{
                    backgroundColor: "var(--isagent-mobile-background-color) !important",
                    borderBottom: (theme) => `1px solid ${alpha(theme.palette.common.white, 0.2)}`
                  }}
                >
                  <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%", py: .5 }}>
                    <Typography
                      sx={{
                        pl: 1,
                        fontSize: "1.5rem",
                        fontWeight: "600",
                        color: "var(--isagent-text-color)"
                      }}
                    >
                      {primaryNavItem.fields.title}
                    </Typography>
                    {Array.isArray(primaryNavItem.fields.subNavList) && primaryNavItem.fields.subNavList.length > 0 && (
                      <KeyboardArrowRightIcon
                        sx={{
                          color: "var(--isagent-text-color)",
                          fontSize: "3.5rem",
                          fontWeight: 600
                        }}
                      />
                    )}
                  </Box>
                </ListItemButton>
              </ListItem>
            ))}
            <ListItem sx={{ alignItems: "center", justifyContent: "center" }}>
              <LoginNavItem />
            </ListItem>
          </List>
        </Box>
        <Divider />
      </Stack>
    </Stack>
  );
}
